// Official SAWA lockup artwork (sawa-brand/logos/svg). Never retype the wordmark: it is custom lettering.
// Full colour on light themes, reversed (white + coral) on dark themes; switched by the body theme class.
import LockupSVG from '$public/res/brand/sawa-lockup.svg';
import LockupReversedSVG from '$public/res/brand/sawa-lockup-reversed.svg';

type SawaLockupProps = {
  /** Rendered height in px; the brand minimum for the mark is 24px. */
  height?: number;
};

export function SawaLockup({ height = 32 }: SawaLockupProps) {
  const style = { height, width: 'auto' };
  return (
    <span className="sawa-lockup" role="img" aria-label="SAWA">
      <img className="sawa-lockup__light" src={LockupSVG} alt="" style={style} />
      <img className="sawa-lockup__dark" src={LockupReversedSVG} alt="" style={style} />
    </span>
  );
}
